import { NgModule , CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartistModule } from 'ng-chartist';
import { SharedModule } from '../../shared/shared.module';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { FirmasPendientesAvanceComponent } from './firmas-pendientes-avance/firmas-pendientes-avance.component';
import { FirmasPendientesAvanceRoutingModule } from './firmas-pendientes-avance-routing.modules';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FirmasPendientesAvanceComponent],
  imports: [
    CommonModule,    
    SharedModule,
    NgChartsModule,
    Ng2GoogleChartsModule,
    NgxChartsModule,
    ChartistModule,
    NgbCollapseModule,
    FirmasPendientesAvanceRoutingModule,
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FirmasPendientesAvanceModule { }
